import createAuthService from "altus-auth";

import config from "infrastructure/config";

export default createAuthService(config);
